export default {
  data() {
    return {
      showForemanDialog: false,
      step: 1,
    };
  },
  computed: {
    bg() { return this.step === 1 ? 'static/bg_front.png' : 'static/bg_manager.png'; },
  },
};
